export default "__VITE_ASSET__CizJKlqk__"